



























































































































import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import JobList from '@/components/JobList.vue';
import { mapActions } from 'vuex';
import axios from 'axios';

@Component({
  components: { JobList }
})
export default class LocationView extends Vue {
  public $auth!: {
    token: string;
  };

  public $refs!: {
    form: HTMLFormElement;
    singleEntryForm: HTMLFormElement;
    googlesheetBulkAdd: HTMLFormElement;
  };

  @(namespace('ProjectModule').Action('getProjects'))
  private getProjects!: (token: string) => null;

  @(namespace('ProjectModule').State('projects')) private projects!: [];

  private valid = false;
  private displayProgressCircle = false;
  private locationName = '';
  private latitude = '';
  private longitude = '';
  private date = '';
  private numberOfDevices = '';
  private project = { projectId: '', projectName: '' };
  private color = '';

  private activeTab = null;

  private snackbar = {
    status: false,
    message: '',
    color: ''
  };

  private sheetName = '';
  private sheetId = '';

  private defaultRule = [value => !!value || 'Required'];

  private latitudeRule = this.defaultRule;
  private longitudeRule = this.defaultRule;
  private addressRule = this.defaultRule;
  private dateRule = this.defaultRule;
  private numberOfDevicesRule = this.defaultRule;
  private radiusRule = this.defaultRule;
  private projectRule = this.defaultRule;
  private projectSelectionBoxRule = this.defaultRule;
  private locationNameRule = this.defaultRule;
  private sheetIdRule = this.defaultRule;
  private sheetNameRule = this.defaultRule;
  private fileInputRule = this.defaultRule;

  private file: string | Blob = null;
  private csvFile = [];
  private fileUrl = null;

  private consoleOutput = 'Console Ouput!';
  private joblist = null;

  private goToJobList() {
    this.activeTab = 3;
  }

  private created() {
    this.getProjects(this.$auth.token);
  }

  private onTabChange(e) {
    this.consoleOutput = '';
  }

  private displaySnackBar(message, color) {
    this.snackbar.status = true;
    this.snackbar.color = color;
    this.snackbar.message = message.toUpperCase();
    this.displayProgressCircle = false;
    this.$refs.form.reset();
  }

  private async submit() {
    if (this.$refs.singleEntryForm.validate()) {
      this.displayProgressCircle = true;
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}api/v1/location`,
          {
            location_name: this.locationName,
            latitude: this.latitude,
            longitude: this.longitude,
            number_of_devices: this.numberOfDevices,
            project_id: this.project
          },
          {
            headers: { Authorization: `Bearer ${this.$auth.token}` }
          }
        );
        this.displaySnackBar(data['message'], 'green');
      } catch (error) {
        this.$store.state.ErrorModule.errorText = error.response.data['error'];
      }
    }
  }

  private async onUploadGoogleSheet() {
    this.displayProgressCircle = true;
    if (this.$refs.googlesheetBulkAdd.validate()) {
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}api/v1/project/${this.project}/upload_location_from_google_sheet`,
          {
            google_sheet_id: this.sheetId,
            sheet_name: this.sheetName
          },
          {
            headers: { Authorization: `Bearer ${this.$auth.token}` }
          }
        );

        this.consoleOutput = `${data.message}
           ${
             data.errors
               ? 'Errors in csv file while validation, <a href="' +
                 data.errors +
                 '">Download Error File</a>'
               : ''
           }`;

        this.displayProgressCircle = false;
      } catch (error) {
        this.$store.state.ErrorModule.errorText = error.response.data['error'];
      }
    }
  }

  private async printLink(e) {
    const data = await axios.get(
      `${process.env.VUE_APP_API_ENDPOINT}xact_template`
    );
  }

  private async onUpload() {
    this.displayProgressCircle = true;
    const formData = new FormData();
    formData.append('file', this.file);

    const token = this.$auth.token;
    const { data } = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}api/v1/project/${this.project}/upload_location_csv`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      }
    );
    this.consoleOutput = `${data.message}
    ${
      data.errors
        ? 'Errors in csv file while validation, <a href="' +
          data.errors +
          '">Download Error File</a>'
        : ''
    }

    `;
    this.displayProgressCircle = false;
  }
}
